import React from "react";
import { Calendar, Clock, CheckCircle2, AlertCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const VisitStats = ({ visits, pendingVisits }) => (
  <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-testid="visit-stats">
    <Card className="border-0 shadow-lg bg-gradient-to-br from-blue-50 to-blue-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-blue-900">Total Visits</CardTitle>
        <Calendar className="h-4 w-4 text-blue-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-blue-900">{visits.length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-yellow-50 to-yellow-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-yellow-900">Ongoing</CardTitle>
        <Clock className="h-4 w-4 text-yellow-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-yellow-900">{visits.filter(v => v.status === 'ongoing').length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-green-50 to-green-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-green-900">Completed</CardTitle>
        <CheckCircle2 className="h-4 w-4 text-green-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-green-900">{visits.filter(v => v.status === 'complete').length}</div></CardContent>
    </Card>
    <Card className="border-0 shadow-lg bg-gradient-to-br from-orange-50 to-orange-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-orange-900">Pending Review</CardTitle>
        <AlertCircle className="h-4 w-4 text-orange-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-orange-900">{pendingVisits.length}</div></CardContent>
    </Card>
  </div>
);
